"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reflowRenderUnitKey = void 0;
const predicate_1 = require("./predicate");
/**
 * 根据现有的规格等交易参数列表和重排配置，生成新的参数顺序
 */
function reflowRenderUnitKey(paramKeyOrder, refineOrder) {
    const paramKeySet = new Set(paramKeyOrder);
    const merged = [];
    for (const key of refineOrder) {
        if ((0, predicate_1.isGroupKey)(key)) {
            merged.push(key);
        }
        else if (paramKeySet.has(key)) {
            merged.push(key);
            paramKeySet.delete(key);
        }
    }
    // TODO: 未被定义顺序的 key，暂时先放到最后面，需要优化算法，尽量放到附近
    for (const newKey of paramKeySet) {
        merged.push(newKey);
    }
    return merged;
}
exports.reflowRenderUnitKey = reflowRenderUnitKey;
